export default __webpack_public_path__ + "static/media/developer-badge-breakdown-empty-state.5a04b529.svg";